// NX toasts on sonner: bottom right, 3.6 s, ink surface with the info icon; notify() is the one call features use.
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon } from "lucide-react";
import type * as React from "react";
import { type ExternalToast, Toaster as Sonner, toast } from "sonner";

function Toaster(props: React.ComponentProps<typeof Sonner>) {
  return (
    <Sonner
      position="bottom-right"
      duration={3600}
      gap={8}
      offset={20}
      visibleToasts={4}
      containerAriaLabel="Notifications"
      icons={{
        info: <InfoIcon className="size-[18px]" aria-hidden />,
        success: <CircleCheckIcon className="size-[18px]" aria-hidden />,
        warning: <TriangleAlertIcon className="size-[18px]" aria-hidden />,
        error: <TriangleAlertIcon className="size-[18px]" aria-hidden />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "z-(--z-toast) flex w-[min(420px,calc(100vw-40px))] min-w-[300px] items-start gap-2.5 rounded-md border border-toast-border bg-toast px-3.5 py-3 text-ui text-toast-foreground shadow-pop",
          icon: "mt-px flex size-[18px] shrink-0 items-center justify-center text-toast-icon",
          content: "flex min-w-0 flex-col gap-0.5",
          title: "font-semibold",
          description: "text-ui opacity-90",
          actionButton:
            "ml-auto shrink-0 rounded-sm bg-white/12 px-2.5 py-1 text-chip font-semibold text-toast-foreground hover:bg-white/20",
          cancelButton: "shrink-0 rounded-sm px-2 py-1 text-chip text-toast-foreground/80",
        },
      }}
      {...props}
    />
  );
}

function notify(title: string, description?: string, options?: ExternalToast): string | number {
  return toast.info(title, { ...options, ...(description === undefined ? {} : { description }) });
}

export { Toaster, notify, toast };
